import React, { useEffect, useState } from 'react';
import './search.css';
import { Notify } from 'notiflix';
import axios from 'axios';
import AdvnaceSearch from '../AdvanceSearch/AdvnaceSearch';
import CommonProfileCard from '../CommonProfileCard/CommonProfileCard';

const SearchComponent = () => {
  const [activeTab, setActiveTab] = useState('advancedSearch');
  const [id, setId] = useState('');
  const [profiles, setProfiles] = useState("");
  const [Reload, setReload] = useState(false);

  const token = JSON.parse(localStorage.getItem("kkm_auth"));
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const fetchProfileById = () => {
    if (!id) {
      Notify.failure("profile id is required");
      return;
    }
    const data = { search_profile_id: id };

    axios.post(
      "https://kovaikongunadumatrimony.com/kkm_backend/public/api/search-profile-id",
      data,
      { headers }
    ).then((response) => {
      if (response.data.status === true) {
        setProfiles(response.data.profile_data);
      } else {
        Notify.failure(response.data.message);
      }
    });
  };

  const handleIdSearch = () => {
    fetchProfileById();
  };

  // 🔹 Re-fetch when Reload changes
  useEffect(() => {
    if (activeTab === 'idSearch' && id) {
      fetchProfileById();
    }
  }, [Reload]);

  const HandleTab = (tab) => {
    if (tab === "advancedSearch") {
      setProfiles("");
    }
    setActiveTab(tab);
  };

  return (
    <div className="search-wrapper px-3">
      <div className="search-container">
        <div className="search-tabs">

          <button
            className={`tab-btn ${activeTab === 'advancedSearch' ? 'active' : ''}`}
            onClick={() => HandleTab('advancedSearch')}
          >
            Advanced Search
          </button>
          <button
            className={`tab-btn ${activeTab === 'idSearch' ? 'active' : ''}`}
            onClick={() => HandleTab('idSearch')}
          >
            ID Search
          </button>
        </div>

        {activeTab === 'idSearch' && (
          <div className="search-card">
            <h5>Search with ID</h5>
            <div className="id-input-group">
              <input
                type="text"
                placeholder="Enter Profile ID"
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
              <button onClick={handleIdSearch}>Search</button>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-6 ps-5">
            {profiles && (
              <CommonProfileCard profile={profiles} setReload={setReload} />
            )}
          </div>
        </div>

        {activeTab === 'advancedSearch' && <AdvnaceSearch />}
      </div>
    </div>
  );
};

export default SearchComponent;
